<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/posrate/select"
      :model="formModel"
      :submitService="submitService"
      @success="onSuccess"
      @openAddDialog="openDialog"
      addShowPower="/posrate/add"
    >
      <el-form-item label="费率名称">
        <el-input
          v-model="formModel.feeName"
         
          placeholder="请输入费率名称"
        ></el-input>
      </el-form-item>
      
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="feeName"
        label="商户费率名称"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="fee"
        label="商户费率"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="fee"
        label="费率"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="machinesFee"
        label="终端费率"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>

      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="modifierId"
        label="操作人"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="180"
        v-if="
          hasPerm('/posrate/update') ||
          hasPerm('/posrate/delete') ||
          hasPerm('/posrate/rate')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="openDialog(scope.row)"
            v-if="hasPerm('/posrate/update')"
            >修改</el-button
          >
       
          <el-button
            type="text"
            @click="posratemanage(scope.row)"
            class="button-color"
            v-if="hasPerm('/posrate/rate')"
            >费率</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    >
      <el-form-item label="商户费率名称" prop="feeName" label-width="120px">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.feeName"
          placeholder="请输入"
          style="width: 203.3px"
        ></el-input>
      </el-form-item>

      <el-form-item label="费率" prop="fee" label-width="120px">
        <div class="flex-row vertical-center flow-justify">
          <el-input-number
            style="width: 203.3px"
            v-model="dialogModel.fee"
            :controls="false"
            :precision="6"
            :step="0.1"
            controls-position="right"
            :min="0"
            placeholder="请输入"
          ></el-input-number>
        </div>
      </el-form-item>
      <el-form-item label="终端费率" prop="machinesFee" label-width="120px">
        <div class="flex-row vertical-center flow-justify">
          <el-input-number
            style="width: 203.3px"
            v-model="dialogModel.machinesFee"
            :controls="false"
            :precision="6"
            :step="0.1"
            controls-position="right"
            :min="0"
            placeholder="请输入"
          ></el-input-number>
        </div>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "@/view/dialog/FormDialog";

import PosService from "service/PosService";
import Merchant from "@/service/Merchant";
import Server from "common/conf/Server";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "posrate",
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      formModel: { feeName: "" },
      submitService: Merchant.posmanageList,
      tableData: [],
      hardwareTypeStatus: [{ id: "", name: "全部" }],
      itemId: "",
      dialogModel: {
        fee: undefined,
        machinesFee: undefined,
        feeName: "",
      },
      dialogRules: {
        feeName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        hardwareTypeName: [
          {
            required: true,
            message: "请选择",
          },
        ],
        fee: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value > 1 || value < 0) {
                callback(new Error("费率不能大于1且不能小于0"));
              } else {
                callback();
              }
            },
          },
        ],
        machinesFee: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value > 1 || value < 0) {
                callback(new Error("终端费率不能大于1且不能小于0"));
              } else {
                callback();
              }
            },
          },
        ],
        imageUrl: [
          {
            required: true,
            message: "请选择你要上传的图片",
          },
        ],
      },
      page: {},
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  mounted() {
    this.formModel = {
      feeName: "",
    };
    // this.gethardwareTypeStatus();
    this.getList();
    this.page = this.$refs.commonTable.page;
  },
  computed: {
    submitData() {
      const params = {
        feeName: this.formModel.feeName,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    dialogData() {
      const params = {
        fee: this.dialogModel.fee,
        machinesFee: this.dialogModel.machinesFee,
        feeName: this.dialogModel.feeName,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }

      return params;
    },
    dialogService() {
      return this.itemId ? Merchant.posrateEdit : Merchant.posrateInsert;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    openDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          console.log(res, "www");
          res.contents.records.forEach((item) => {
            this.hardwareTypeStatus.push({
              id: item.feeName,
              name: item.feeName,
            });
          });
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    deleteInfo(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        Merchant.posrateDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        fee: undefined,
        machinesFee: undefined,
        feeName: "",
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.records;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    gethardwareTypeStatus() {
      //硬件产品类型
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = [
              ...this.hardwareTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imageUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    posratemanage(item) {
      this.$router.push({
        name: "aamerchantmange",
        params: {
          item: JSON.stringify(item),
        },
      });
    },
  },
};
</script>

<style scoped>
.type-title {
  font-size: 20px;
  color: #000;
}

.type-msg {
  font-size: 20px;
  color: #aaaaaa;
  margin-left: 10px;
}

.box-card {
  margin-bottom: 30px;
}

.unit {
  margin-left: 10px;
  color: #aaaaaa;
}

.levelList {
  display: flex;
  flex-wrap: wrap;
}

.type-box {
  margin-bottom: 22px;
}

.people-check {
  text-align: right;
  padding-right: 12px;
  margin-bottom: 20px;
  padding-left: 90px;
}

.up-people-list {
  padding-left: 90px;
}

.upPeople-desc {
  margin-bottom: 20px;
  font-weight: bold;
}

.pad-right {
  padding-right: 70px;
}

.pad-left {
  padding-left: 90px;
}

.mar_bot {
  margin-bottom: 20px;
}

.notice-text {
  color: #aaaaaa;
  margin-top: -10px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AAmerchantrates.vue